export const NAME = 'name';
export const URL = 'url';
export const ROOT_HTML_URL = 'rootHtmlUrl';
export const THUMBNAIL_URL = 'thumbnailUrl';
export const SCRUBBING_URLS = 'scrubbingUrls';
export const WIDTH = 'width';
export const HEIGHT = 'height';
export const SIZE = 'size';
export const VIDEO_LENGTH = 'videoLength';
export const ORIENTATION = 'orientation';
export const EXTENSION = 'extension';
export const RATIO = 'ratio';
